import { render } from "./GuessTheBalance.vue?vue&type=template&id=7f91a7df&scoped=true"
import script from "./GuessTheBalance.vue?vue&type=script&lang=js"
export * from "./GuessTheBalance.vue?vue&type=script&lang=js"

import "./GuessTheBalance.vue?vue&type=style&index=0&id=7f91a7df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f91a7df"]])

export default __exports__